export type DeviceClass = 'mobile' | 'tablet' | 'desktop';

export interface DeviceInfo {
  DeviceClass: DeviceClass;
  InputType: 'touch' | 'mouse';
  Screen: string;
  Viewport: string;
  PixelRatio: number;
  PwaInstalled: boolean;
  Online: boolean;
}

type DeviceNavigator = Navigator & {
  userAgentData?: { mobile?: boolean };
  standalone?: boolean;
};

export function getDeviceInfo(win: Window = window): DeviceInfo {
  const nav = win.navigator as DeviceNavigator;
  const touch = matchesMedia(win, '(pointer: coarse)');

  return {
    DeviceClass: getDeviceClass(nav, touch),
    InputType: touch ? 'touch' : 'mouse',
    Screen: `${win.screen?.width ?? 0}x${win.screen?.height ?? 0}`,
    Viewport: `${win.innerWidth}x${win.innerHeight}`,
    PixelRatio: win.devicePixelRatio,
    PwaInstalled: matchesMedia(win, '(display-mode: standalone)') || nav.standalone === true,
    Online: nav.onLine,
  };
}

function getDeviceClass(nav: DeviceNavigator, touch: boolean): DeviceClass {
  if (nav.userAgentData?.mobile ?? /Mobi|iPhone/i.test(nav.userAgent)) {
    return 'mobile';
  }
  // iPadOS reports a desktop Mac user agent.
  const iPad = nav.platform === 'MacIntel' && nav.maxTouchPoints > 1;
  return touch || iPad ? 'tablet' : 'desktop';
}

function matchesMedia(win: Window, query: string): boolean {
  return win.matchMedia?.(query)?.matches ?? false;
}
